<template>
    <div class="ku-location">
        <div class="add" v-if="address.length === 0 && key_check"><span>请确认</span>您外卖地址区域</div>
        <div class="add" v-if="address.length === 0 && !key_check"><span>请输入</span>您外卖地址区域</div>
        <div class="add" v-if="address.length > 0">请选择本次配送地址</div>
        <van-cell-group>
            <van-cell v-for="(item, index) in address" :key="index" @click="setAddress(item)">
                <span>{{ item.address }}</span>
                <van-icon name="cross" @click.stop="delAddress(item)"/>
            </van-cell>
        </van-cell-group>
        <div v-show="!list_check">
            <van-button size="small" type="primary" class="add_check" @click="add_check">新增配送地址</van-button>
        </div>
        <van-field v-model="data.address" @input="schoolNameChange" v-show="list_check">
            <template #button>
                <van-button size="small" type="primary" @click="setShop(1)">确定</van-button>
            </template>
        </van-field>
        <div class="select">
            <div v-for="(item, index) in list" :key="index" @click="setKey(item)">
                <span>{{ item.title }}</span>
                <label>{{ item.address }}</label>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {Field, Button, Notify, Cell, CellGroup, Icon, Dialog} from 'vant';
import {getCookie, setCookie} from "@/utils/auth";
import router from "@/router";
import {VueJsonp} from 'vue-jsonp';

Vue.use(Field).use(Button).use(Notify).use(Cell).use(CellGroup).use(Icon).use(Dialog);
Vue.use(VueJsonp);

export default {
    data() {
        return {
            key_check: false,
            region: '中国',
            list: [],
            amap: [],
            address: [],
            data: {
                lat: '',
                lng: '',
                address: '',
            },
            list_check: true
        };
    },
    mounted() {
        let key_check = getCookie('key_check');
        let address = getCookie('address')
        if (key_check) {
            this.key_check = key_check
            this.data.lat = getCookie('lat');
            this.data.lng = getCookie('lng');
            this.data.address = address
        }
        this.getUserAddress()
        this.geocoder()
    },
    methods: {
        getUserAddress() {
            this.$API.getUserAddress().then(res => {
                this.address = res.data.data
                if (this.address.length > 0) {
                    this.list_check = false
                    // 存储用户基本信息
                    setCookie('user_address', JSON.stringify(this.address[0]))
                }
            })
        },
        add_check() {
            this.list_check = true
            this.data = {
                lat: '',
                lng: '',
                address: '',
            }
        },
        // 设置地址
        setAddress(e) {
            setCookie('lat', e.lat)
            setCookie('lng', e.lng)
            setCookie('address', e.title)
            setCookie('amap', JSON.stringify(this.amap))
            if (e.id > 0) {
                setCookie('user_address', JSON.stringify(e))
            }
            this.$API.sendLatLng({
                lat: e.lat,
                lng: e.lng
            }).then(() => {
                router.push('/shop')
            })
        },
        // 地址删除
        delAddress(item) {
            Dialog.confirm({
                message: '确认删除地址吗？',
            }).then(() => {
                this.$API.delUserAddress({id: item.id}).then(() => {
                    Notify({type: 'success', message: '删除成功'});
                    this.getUserAddress()
                })
            }).catch(() => {
                // on cancel
            });
        },
        geocoder() {
            const that = this;
            let lat = getCookie('lat')
            let lon = getCookie('lng')
            this.$jsonp("https://apis.map.qq.com/ws/geocoder/v1/", {
                location: lat + ',' + lon,
                key: "TDJBZ-YZMCF-QIRJG-JUA4K-3ELO5-HNBFD",
                output: 'jsonp'
            }).then(res => {
                if (res.status === 0) {
                    that.region = res.result.address_component.city
                    that.setKeys(res.result)
                }
                console.log(that.region)
            }).catch(err => {
                console.log("catch", err);
            });
        },
        schoolNameChange() {
            const that = this;
            const schoolName = this.data.address;
            this.$jsonp("https://apis.map.qq.com/ws/place/v1/suggestion/", {
                region: that.region,
                keyword: schoolName,
                key: "TDJBZ-YZMCF-QIRJG-JUA4K-3ELO5-HNBFD",
                output: 'jsonp'
            }).then(res => {
                that.list = res.data;
            }).catch(err => {
                console.log("catch", err);
            });
        },
        setKey(e) {
            this.data.address = e.title
            this.list = []
            this.amap = e
            console.log(this.amap)
        },
        setKeys(e) {
            let that = this;
            this.amap = {
                "title": that.data.address,
                "address": that.data.address,
                "type": 1,
                "location": e.location,
                "adcode": e.ad_info.adcode,
                "province": e.ad_info.province,
                "city": e.ad_info.city,
                "district": e.ad_info.district
            }
            this.setShop()
        },
        setShop(type) {
            let that = this
            if (that.data.address.length === 0) {
                Notify('请先选择地址')
                return false;
            }
            that.$API.getShopList({address: that.amap}).then(res => {
                let data = res.data.data;
                console.log(that.amap)
                console.log(data)
                if (data.count >= 1) {
                    let user_address = getCookie('user_address');
                    if (user_address !== 'undefined' && user_address !== '' && user_address !== null) {
                        user_address = JSON.parse(user_address)
                        user_address.id = 0
                        user_address.address = ''

                        setCookie('user_address', JSON.stringify(user_address))
                    }
                    if (this.address.length <= 0 || type) {
                        that.setAddress({
                            title: that.amap.title,
                            lat: that.amap.location.lat,
                            lng: that.amap.location.lng,
                        })
                    }
                } else {
                    Notify('抱歉！您所在的区域没有可配送商家')
                }
            })
        }
    },
};
</script>

<style lang="less" scoped>
.ku-location {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #50AFA7;

    .add_check {
        background: #2DA297;
        border-color: #2DA297;
        font-size: 30px;
        border-radius: 10px;
        padding: 10px 30px;
        margin-top: 50px;
    }

    .add {
        font-size: 40px;
        line-height: 120px;
        color: #ffffff;
        margin-top: 30px;

        span {
            color: #FFF100;
        }
    }

    .van-cell-group {
        background: none;
        padding: 10px 10px;
        position: relative;

        &:after {
            display: none;
        }

        .van-cell {
            background: none;
            border-bottom: 1px solid #EFEA3C;
            padding: 10px 16px;
            line-height: 60px;

            &:after {
                display: none;
            }

            .van-cell__value {
                color: #FFF100;
                text-align: center;
                font-size: 26px;
            }

            &:nth-child(1) {
                border-top: 1px solid #EFEA3C;
            }
        }

        .van-icon {
            position: absolute;
            right: 5px;
            top: 14px;
            background: #F8B62D;
            color: #ffffff;
            border-radius: 50%;
            font-size: 24px;
            padding: 3px;
        }
    }

    .van-address-list__bottom {
        background: none;
    }

    .van-field {
        margin: 0 30px;
        width: auto;
    }

    .select {
        background: #fff;
        margin: 0 30px;
        div {
            height: 60px;
            overflow: hidden;
            line-height: 60px;
            text-align: left;
            padding: 0 30px;

            span {
                font-size: 28px;
            }

            label {
                color: #969799;
                padding-left: 5px;
            }
        }
    }
}
</style>
